import { UpOutlined } from "@ant-design/icons";
import { Button, Tag } from "antd";
import React from "react";

const SegmentCell: React.FC<{ segs: string[] }> = React.memo(({ segs }) => {
  const [expanded, setExpanded] = React.useState(false);
  if (!segs?.length) return null;

  const [first, ...rest] = segs;
  const toggle = () => setExpanded((v) => !v);

  return (
    <div>
      <Tag>{first}</Tag>

      {rest.length > 0 && !expanded && (
        <Button
          size="small"
          onClick={toggle}
          aria-expanded={expanded}
          style={{ backgroundColor: "#E5E7EB", fontSize: 10 }}
        >
          +{rest.length} more
        </Button>
      )}

      {expanded && (
        <>
          {rest.map((s, idx) => (
            <div key={`${s}-${idx}`} style={{ marginTop: 4 }}>
              <Tag>{s}</Tag>
            </div>
          ))}
          <div style={{ marginTop: 4 }}>
            <Button
              size="small"
              onClick={toggle}
              style={{ backgroundColor: "#E5E7EB", fontSize: 10 }}
            >
              <UpOutlined style={{ fontSize: 10 }} /> less
            </Button>
          </div>
        </>
      )}
    </div>
  );
});

export default SegmentCell;
